import type { SandboxActionName } from '../../../lib/api/operatorConsole';

interface SandboxActionCopy {
  label: string;
  runningLabel: string;
  hint: string;
  confirm: (shippingId: number) => string;
  done: string;
}

// Every action is irreversible and moves real test money on the partner's
// side, so each confirmation names what their integration will receive.
export const SANDBOX_ACTIONS: Record<SandboxActionName, SandboxActionCopy> = {
  mark_shipped: {
    label: 'Mark shipped',
    runningLabel: 'Shipping…',
    hint: 'Every card still waiting ships. Carrier and tracking number are optional.',
    confirm: (id) =>
      `Mark delivery #${id} as shipped? Every card still waiting ships now: shipping.shipped goes ` +
      'to your webhook endpoints and, on a seamless wallet, each round it closes gets a zero-amount ' +
      'Shipping Settle callback (/shipping-settle). This cannot be undone.',
    done: 'Delivery marked shipped.',
  },
  mark_delivered: {
    label: 'Mark delivered',
    runningLabel: 'Delivering…',
    hint: 'Stands in for the carrier’s delivered scan.',
    confirm: (id) =>
      `Mark delivery #${id} as delivered? shipping.delivered goes to your webhook endpoints. ` +
      'This cannot be undone.',
    done: 'Delivery marked delivered.',
  },
  cancel: {
    label: 'Cancel delivery',
    runningLabel: 'Canceling…',
    hint: 'Cards still waiting are bought back and the fees refunded.',
    confirm: (id) =>
      `Cancel delivery #${id}? Every card still waiting is bought back at the buyback price and ` +
      'the shipping and handling fees (sales tax included) are refunded — on a seamless wallet as /credit and /refund ' +
      'callbacks. This cannot be undone.',
    done: 'Delivery canceled.',
  },
};
